import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { PartnerPayment, PartnerPaymentHistory, PartnerPaymentSendCashback } from '@models/partner/payments/partner-payment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PartnerPayamentsService {
  private readonly baseUrl;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getTotalProfit(): Observable<any> {
    const url = this.baseUrl + '/partner/payout/profit';
    return this.http.get<Response>(url);
  }

  listCashbackHistory(page?, size?, sortColumn?, sortDirection?): Observable<PartnerPayment> {
    const url = this.baseUrl + '/partner/payout/cashback-history';
    let params = new HttpParams();
    if (page) {
      params = params.append('page', page);
    }
    if (size) {
      params = params.append('size', size);
    }
    if (sortColumn) {
      params = params.append('sortColumn', sortColumn);
    }

    if (sortDirection) {
      params = params.append('sortDirection', sortDirection);
    } else {
      params = params.append('sortDirection', 'd');
    }

    return this.http.get(url, { params }).pipe(
      map(data => {
        return PartnerPaymentHistory.deserialize(data);
      })
    );
  }

  sendCashbackMail(requestBody: PartnerPaymentSendCashback) {
    const url = this.baseUrl + '/partner/payout/send-cashback-mail';
    return this.http.post(url, requestBody);
  }
}
